import { Platform } from "../constants";

import { ConstructDestinationUrl, URLVerification } from "./components/utms";
import { type PlatformDetails } from "./platform-details";

const PLATFORM = Platform.OTHER;

export const OtherDetails: PlatformDetails = {
  northbeamDocUrl:
    "https://docs.northbeam.io/docs/tracking-for-other-platforms#if-your-platform-is-not-in-the-guide-please-use-standard-utm-parameters",
  officialDocUrl: "",
  additionalDetails: [
    {
      title: "What if you have sources that are not in the Guide?",
      content:
        "Use our generic utm parameters to be able to pass through data to your dashboard.",
    },
  ],
};

export const OtherSetup = () => (
  <>
    <ConstructDestinationUrl platform={PLATFORM} />
    <URLVerification platform={PLATFORM} />
  </>
);
